import {
  profiles,
  studiesIds,
  unauthorizedStudyStatus,
} from "../../modules/constants";
import AdminLanding from "../../pages/LCF302/Admin/Landing";
import ParticipantLanding from "../../pages/LCF302/Participant/Landing";
import Stats from "../../pages/LCF302/Stats";
import Favorites from "../../pages/LCF302/Participant/Favorites";
import ChangeRequests from "../../pages/LCF302/ChangeRequests";
import DataComments from "../../pages/LCF302/Admin/DataComments";
import Management from "../../pages/LCF302/Admin/Management";
import ParticipantCaregivers from "../../pages/LCF302/Admin/ParticipantCaregivers";
import AdminParticipantCaregivers from "../../pages/LCF302/Admin/AdminParticipantCaregivers";
import LCF302AuditTrail from "../../pages/LCF302/Admin/AuditTrail";

export default [
  {
    path: "/study",
    genericRoute: true,
    authorize: [
      profiles.participant,
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
  },
  {
    path: "/participant",
    component: ParticipantLanding,
    authorize: [profiles.participant],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod302,
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/admin",
    component: AdminLanding,
    authorize: [
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/stats/:participantId?",
    component: Stats,
    authorize: [
      profiles.participant,
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod302,
    redirectNonStudyEnrolled: "/accessdenied",
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/favorites",
    component: Favorites,
    authorize: [profiles.participant],
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod302,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/change-requests",
    component: ChangeRequests,
    authorize: [
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/data-comments",
    component: DataComments,
    authorize: [profiles.pi, profiles.medicalMonitor],
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/management",
    component: Management,
    authorize: [profiles.itAdmin],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/caregivers/:participantUsername/:participantId",
    component: ParticipantCaregivers,
    authorize: [
      profiles.participant,
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod302,
    redirectNonStudyEnrolled: "/accessdenied",
    study: studiesIds.lcfaod302,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/admin/caregivers/:participantUsername/:participantId",
    component: AdminParticipantCaregivers,
    authorize: [profiles.itAdmin],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/audittrail",
    component: LCF302AuditTrail,
    authorize: [
      profiles.dietitian,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.siteMonitor,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.studyAdmin,
      profiles.itAdmin,
    ],
    redirectNonAuthorized: "/unauthorized",
    study: studiesIds.lcfaod302,
    withNavbar: true,
    withSidebar: true,
    hideAuditTrailCommentButton: true,
  },
];
